import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'

function PageBlocked() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <div>
                    <h1>Page not available</h1>
                    <p>This page has been switched off for your organisation. Contact Sentinel if you need access.</p>
                </div>
            </MainView>
        </div>
    )
}

export default PageBlocked
